import React from "react";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as FiIcons from "react-icons/fi";

export const SidebarData = [
  {
    title: "Home",
    path: "/home",
    icon: <AiIcons.AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Snag Board",
    path: "/snag-board",
    icon: <IoIcons.IoIosSync />,
    cName: "nav-text",
  },
  {
    title: "Site Viewer",
    path: "/sitespage",
    icon: <IoIcons.IoMdArchive />,
    cName: "nav-text",
  },
  {
    title: "User Groups",
    path: "/user-groups",
    icon: <FiIcons.FiUsers />,
    cName: "nav-text",
  },
  {
    title: "Shifts",
    path: "/shifts",
    icon: <FiIcons.FiCalendar />,
    cName: "nav-text",
  },
  {
    title: "Operations",
    path: "/operations",
    icon: <FiIcons.FiClipboard />,
    cName: "nav-text",
  },
  {
    title: "Reports",
    path: "/reports",
    icon: <IoIcons.IoIosPaper />,
    cName: "nav-text",
  },

];
